export const projects = [
  {
    id: 1,
    title: "🛡️ Sentinel - Advanced System Monitoring & Alerting",
    description: "A comprehensive cybersecurity monitoring tool that provides real-time system monitoring, security alerting, and threat detection capabilities. Built with Python OOP principles and modern web technologies including FastAPI, PostgreSQL, and real-time streaming.",
    tags: ["Python", "FastAPI", "PostgreSQL", "Cybersecurity", "System Monitoring"],
    tools: ["Python 3.8+", "FastAPI", "PostgreSQL", "psycopg2", "asyncio", "CLI"],
    image: "sentinel.png",
    link: "https://github.com/ilan-uzan/sentinel",
    features: [
      "Real-time Process Monitoring",
      "Network Connection Analysis", 
      "Security Rule Engine",
      "RESTful API with 15+ endpoints",
      "Server-Sent Events for live monitoring",
      "Interactive CLI with progress bars",
      "PostgreSQL storage with JSONB support"
    ]
  },
  {
    id: 2,
    title: "🚀 Kesef Plus - Financial Technology Platform",
    description: "A next-generation fintech project being built in Tel Aviv that simplifies money management for the modern generation. Combines multiple financial tools into one platform with clean, intuitive design powered by smart automation and AI.",
    tags: ["React Native", "Node.js", "Supabase", "Fintech", "AI", "Web3"],
    tools: ["React Native (Expo)", "Tailwind-RN", "Node.js", "Express", "Supabase", "PostgreSQL", "Plaid", "Stripe", "OpenAI", "OneSignal"],
    image: "kesefpluslogo.png",
    link: "https://kesefplus.app",
    features: [
      "Glassmorphism Apple-style design",
      "AI-powered financial automation",
      "Plaid & Stripe integrations",
      "Supabase authentication & database",
      "Push notifications with OneSignal",
      "Preparing for closed beta testing"
    ]
  },
  {
    id: 3,
    title: "🤖 CeeVee AI - AI-Powered CV Generator",
    description: "Build the perfect CV in minutes with AI. A smart CV and motivation letter generator powered by Google Gemini, featuring real-time preview, modern glassmorphism UI, and professional PDF export capabilities.",
    tags: ["Next.js", "TypeScript", "AI/ML", "Google Gemini", "Firebase", "CV Generator"],
    tools: ["Next.js 14", "TypeScript", "Tailwind CSS", "Firebase Auth", "Firestore", "Google Gemini AI", "jsPDF", "html2canvas"],
    image: "ceevee.png",
    link: "https://github.com/ilan-uzan/ceevee-ai",
    features: [
      "Google Gemini powered CV generation",
      "Real-time preview updates",
      "Beautiful glassmorphism design",
      "Pre-built job role templates",
      "Google Sign-in authentication",
      "Professional PDF export"
    ]
  },
  {
    id: 4,
    title: "🎮 Galactic Defenders - Space Invaders Reimagined",
    description: "A modern reimagining of the classic Space Invaders arcade game, built with Python and Tkinter. Features progressive difficulty, local leaderboard system, and adaptive enemy behavior with educational space facts.",
    tags: ["Python", "Game Development", "Tkinter", "Arcade Game", "SQLite", "Educational"],
    tools: ["Python 3.8+", "Tkinter", "SQLite3", "Requests", "Faker", "Custom Graphics"],
    image: "galacticdefender.png",
    link: "https://github.com/ilan-uzan/galacticdefendersv2",
    features: [
      "Classic arcade gameplay with modern enhancements",
      "Progressive difficulty system",
      "Local leaderboard with SQLite database",
      "Dynamic visual effects and particle systems",
      "Educational space facts after each game",
      "Mobile-friendly design optimization"
    ]
  }
]; 
